const setNativeProperty = (element, value, property = 'value') => {
  const { set: valueSetter } = Object.getOwnPropertyDescriptor(element, property) || {};
  const prototype = Object.getPrototypeOf(element);
  const { set: prototypeValueSetter } = Object.getOwnPropertyDescriptor(prototype, property) || {};

  if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else if (valueSetter) {
    valueSetter.call(element, value);
  } else {
    throw new Error(`The given element does not have a ${property} setter`);
  }
};

export default setNativeProperty;
